import { SVGProps, Ref, forwardRef } from 'react';

export const MicCrossedOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="m15.5 14.5-1 .995-3.29-3.29c-.767.386-1.63.596-2.512.666V14.1h2.596v1.4H4.629v-1.4h2.669v-1.229c-2.543-.203-4.919-1.559-5.303-4.971h1.41c.179 1.3.706 2.1 1.32 2.607.806.665 1.964.992 3.273.992.785 0 1.517-.118 2.15-.356l-.84-.84a4.2 4.2 0 0 1-1.31.197c-1.666 0-3.333-.833-3.333-3.332V5.66L.5 1.495 1.5.5zM8.103 9.098 6.065 7.06v.108c0 .913.288 1.32.538 1.528.295.245.77.404 1.395.404q.052 0 .105-.002"
                    fill="currentColor"
                />
                <path
                    d="M13.267 10.272c.37-.647.627-1.432.733-2.372h-1.41a4.9 4.9 0 0 1-.364 1.331z"
                    fill="currentColor"
                />
                <path
                    d="M11.215 8.22q.114-.468.115-1.052V3.835c0-2.5-1.666-3.332-3.332-3.332-1.18 0-2.361.418-2.95 1.55L6.136 3.14c.1-.445.293-.688.468-.833.295-.245.77-.404 1.395-.404s1.1.159 1.395.404c.25.208.537.615.537 1.528v3.1z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
MicCrossedOutlinedSize16Glyph.displayName = 'MicCrossedOutlinedSize16Glyph';
